import React, { forwardRef, useState } from 'react';
import PropTypes from 'prop-types';
import FormInput from '../FormInput';
import { IconEye, IconEyeOff } from '@tabler/icons-react';

const FormPasswordInput = forwardRef(({
	type: _type,
	rightSection,
	rightIcon,
	...props
}, ref) => {
	const [visible, setVisible] = useState(false);

	const toggleButton = (
		<button
			type="button"
			onClick={() => setVisible((prev) => !prev)}
			style={{
				background: 'none',
				border: 'none',
				padding: 0,
				cursor: 'pointer',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				color: 'var(--q-text-muted, #6b7280)',
			}}
			tabIndex={-1}
			aria-label={visible ? 'Hide password' : 'Show password'}
		>
			{visible ? <IconEyeOff size={16} /> : <IconEye size={16} />}
		</button>
	);

	return (
		<FormInput
			ref={ref}
			type={visible ? 'text' : 'password'}
			rightSection={rightSection || rightIcon || toggleButton}
			{...props}
		/>
	);
});

FormPasswordInput.displayName = 'FormPasswordInput';

FormPasswordInput.propTypes = {
	type: PropTypes.string,
	rightSection: PropTypes.node,
	rightIcon: PropTypes.node,
};

export default FormPasswordInput;
